import { createActions } from 'reduxsauce';

export interface IPartnersState {
  data: IPartnersData;
  isLoading: boolean;
  error: string;
}
export interface IPartnersData {
  partners: IPartners[];
}

export interface IPartners {
  client_id: number;
  client_name: string;
  subscription_level: string;
}

export type PartnerProps = {
  search_str?: string | number;
  partner_ids?: string[];
};

export interface PartnerTypes {
  PARTNERS: 'PARTNERS';
  PARTNERS_START: 'PARTNERS_START';
  PARTNERS_SUCCESS: 'PARTNERS_SUCCESS';
  PARTNERS_ERROR: 'PARTNERS_ERROR';
  PARTNERS_CLEAN_UP: 'PARTNERS_CLEAN_UP';
}

const { Types, Creators } = createActions<PartnerTypes>({
  partners: ['data'],
  partnersStart: null,
  partnersSuccess: ['data'],
  partnersError: ['error'],
  partnersCleanUp: null,
});

export { Types };

export default Creators;
